import { render, staticRenderFns } from "./draggable-sidebar.vue?vue&type=template&id=72784d44&scoped=true&"
import script from "./draggable-sidebar.vue?vue&type=script&lang=js&"
export * from "./draggable-sidebar.vue?vue&type=script&lang=js&"
import style1 from "./draggable-sidebar.vue?vue&type=style&index=1&id=72784d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72784d44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VSpacer,VToolbar,VToolbarTitle})
